module.exports = __webpack_public_path__ + "static/media/image-768.18540a3c.webp";